import React from 'react';

interface PlayIconProps {
  className?: string;
  onClick?: () => void;
}

function PlayIcon({ onClick, className }: PlayIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" onClick={onClick} className={className}>
      <circle cx="28" cy="28" r="28" fill="currentColor"></circle>
      <path fill="#fff" d="M45 28 19.5 42.722V13.278z"></path>
    </svg>
  );
}

export default PlayIcon;
